import { computed } from '@ember/object';
import { alias, notEmpty, reads } from '@ember/object/computed';
import { isPresent } from '@ember/utils';
import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { underscore } from '@ember/string';

// TODO (cren@): we can remove large part of this file once we have ListContacts migrated to SearchContacts

// Top level filter types
export const Type = new Enum(['SKIPPED', 'CREATION_SOURCE_FILTER', 'CUSTOM_ATTRIBUTE_BOOLEAN', 'CUSTOM_ATTRIBUTE_EMAIL', 'CUSTOM_ATTRIBUTE_ENUM', 'CUSTOM_ATTRIBUTE_PHONE', 'CUSTOM_ATTRIBUTE_TEXT', 'FEEDBACK', 'GROUP_FILTER', 'HAS_CARD_ON_FILE', 'HAS_LOYALTY', 'HAS_VISITED_LOCATION', 'IS_INSTANT_PROFILE', 'LAST_PAYMENT_IN_LAST_Y_DAYS', 'MANUAL_GROUP', 'MARKETING_SUBSCRIBER', 'NO_PAYMENT_IN_LAST_Y_DAYS', 'SEARCH_QUERY', 'X_PAYMENTS_IN_LAST_Y_DAYS', 'PAYMENT', 'BOOKING', 'CASH_BRAND_FOLLOWING']);

// Payment filter subtypes
export const PaymentType = new Enum(['PURCHASE_DATE', 'ITEM', 'CATEGORY', 'LOCATION', 'TOTAL_SPENT', 'PURCHASE_COUNT', 'FIRST_VISIT', 'LAST_VISIT', 'SALES_CHANNEL']);

// Booking filter subtypes
export const BookingFilterType = new Enum(['BOOKED_WITH', 'FIRST_BOOKING_DATE', 'LAST_BOOKING_DATE', 'BOOKING_DATE', 'BOOKED_SERVICE']);

// suggested smart groups
export const SuggestedSmartGroupsType = new Enum(['POPULAR_ITEM', 'POPULAR_SERVICE', 'RECENT_PURCHASERS', 'TOP_SPENDERS', 'SERVICE_WITH_STAFF_MEMBER', 'UPCOMING_BOOKERS']);
const KEY_PREFIX = 'squareup.rolodex';
const KEY_CAB_ATTRIBUTE_TOKEN = `${KEY_PREFIX}.CustomAttributeBoolean.cab_attribute_token`;
const KEY_CAB_ATTRIBUTE_VALUE = `${KEY_PREFIX}.CustomAttributeBoolean.cab_attribute_value`;
const KEY_CAE_ATTRIBUTE_TOKEN = `${KEY_PREFIX}.CustomAttributeEmail.cae_attribute_token`;
const KEY_CAE_ATTRIBUTE_VALUE = `${KEY_PREFIX}.CustomAttributeEmail.cae_attribute_value`;
const KEY_CAEN_ATTRIBUTE_TOKEN = `${KEY_PREFIX}.CustomAttributeEnum.caen_attribute_token`;
const KEY_CAEN_ATTRIBUTE_VALUES = `${KEY_PREFIX}.CustomAttributeEnum.caen_attribute_values`;
const KEY_CAEN_ATTRIBUTE_OPTIONS = `${KEY_PREFIX}.CustomAttributeEnum.caen_attribute_options`;
const KEY_CAEN_CONDITION = `${KEY_PREFIX}.CustomAttributeEnum.caen_condition`;
const KEY_CAP_ATTRIBUTE_TOKEN = `${KEY_PREFIX}.CustomAttributePhone.cap_attribute_token`;
const KEY_CAP_ATTRIBUTE_VALUE = `${KEY_PREFIX}.CustomAttributePhone.cap_attribute_value`;
const KEY_CAT_ATTRIBUTE_TOKEN = `${KEY_PREFIX}.CustomAttributeText.cat_attribute_token`;
const KEY_CAT_ATTRIBUTE_VALUE = `${KEY_PREFIX}.CustomAttributeText.cat_attribute_value`;
const KEY_CAT_CONDITION = `${KEY_PREFIX}.CustomAttributeText.cat_condition`;
const KEY_CSF_CS_CREATION_SOURCE_TYPES = `${KEY_PREFIX}.CreationSourceFilter.cs_creation_source_types`;
const KEY_CSF_CS_CREATION_SOURCE_TYPES_OPTIONS = `${KEY_PREFIX}.CreationSourceFilter.cs_creation_source_types_options`;
const KEY_FB_SENTIMENT_TYPE = `${KEY_PREFIX}.Feedback.fb_sentiment_type`;
const KEY_FB_SENTIMENT_TYPE_OPTIONS = `${KEY_PREFIX}.Feedback.fb_sentiment_type_options`;
const KEY_GF_GROUP_TOKEN = `${KEY_PREFIX}.GroupFilter.gf_group_token`;
export const KEY_HCOF_HAS_CARD_ON_FILE = `${KEY_PREFIX}.HasCardOnFile.hcof_has_card_on_file`;
const KEY_HL_HAS_LOYALTY = `${KEY_PREFIX}.HasLoyalty.hl_has_loyalty`;
const KEY_HVL_LOCATIONS = `${KEY_PREFIX}.HasVisitedLocation.hvl_locations`;
const KEY_HVL_LOCATIONS_OPTIONS = `${KEY_PREFIX}.HasVisitedLocation.hvl_locations_options`;
const KEY_IIP_IS_INSTANT_PROFILE = `${KEY_PREFIX}.IsInstantProfile.iip_is_instant_profile`;
export const KEY_LPILYD_Y_DAYS = `${KEY_PREFIX}.LastPaymentInLastYDays.lpilyd_y_days`;
export const KEY_LPILYD_Y_DAYS_OPTIONS = `${KEY_PREFIX}.LastPaymentInLastYDays.lpilyd_y_days_options`;
const KEY_MG_GROUP_TOKENS = `${KEY_PREFIX}.ManualGroup.mg_group_tokens`;
const KEY_NPILYD_Y_DAYS = `${KEY_PREFIX}.NoPaymentInLastYDays.npilyd_y_days`;
const KEY_NPILYD_Y_DAYS_OPTIONS = `${KEY_PREFIX}.NoPaymentInLastYDays.npilyd_y_days_options`;
export const KEY_SQ_SEARCH_QUERY = `${KEY_PREFIX}.SearchQuery.sq_search_query`;
const KEY_XPILYD_X_PAYMENTS = `${KEY_PREFIX}.XPaymentsInLastYDays.xpilyd_x_payments`;
const KEY_XPILYD_X_PAYMENTS_FIELD_NAME = `${KEY_PREFIX}.XPaymentsInLastYDays.xpilyd_x_payments_field_name`;
const KEY_XPILYD_Y_DAYS = `${KEY_PREFIX}.XPaymentsInLastYDays.xpilyd_y_days`;
const KEY_XPILYD_Y_DAYS_OPTIONS = `${KEY_PREFIX}.XPaymentsInLastYDays.xpilyd_y_days_options`;
const KEY_XPILYD_Y_DAYS_FIELD_NAME = `${KEY_PREFIX}.XPaymentsInLastYDays.xpilyd_y_days_field_name`;
export const SUPPORTED_FILTER_TYPES = [Type.CREATION_SOURCE_FILTER, Type.CUSTOM_ATTRIBUTE_BOOLEAN, Type.CUSTOM_ATTRIBUTE_EMAIL, Type.CUSTOM_ATTRIBUTE_ENUM, Type.CUSTOM_ATTRIBUTE_PHONE, Type.CUSTOM_ATTRIBUTE_TEXT, Type.FEEDBACK, Type.HAS_CARD_ON_FILE, Type.HAS_LOYALTY, Type.HAS_VISITED_LOCATION, Type.LAST_PAYMENT_IN_LAST_Y_DAYS, Type.MANUAL_GROUP, Type.NO_PAYMENT_IN_LAST_Y_DAYS, Type.X_PAYMENTS_IN_LAST_Y_DAYS, Type.IS_INSTANT_PROFILE, Type.CASH_BRAND_FOLLOWING];
export const Condition = new Enum(['UNKNOWN', 'CONTAINS', 'EQUALS']);
export const Option = ProtoBaseModel.extend({
  value: attr(String),
  label: attr(String)
});
const Filter = ProtoBaseModel.extend({
  type: attr(Type),
  displayName: attr(String),
  copy() {
    return this.constructor.deserialize(this.constructor.serialize(this));
  }
});
export default Filter;

// Filter definitions:

const CAB_ATTRIBUTES = [{
  key: KEY_CAB_ATTRIBUTE_TOKEN,
  name: 'cabAttributeToken'
}, {
  key: KEY_CAB_ATTRIBUTE_VALUE,
  name: 'cabAttributeValue'
}];
export const CustomAttributeBoolean = Filter.extend({
  cabAttributeToken: attr(String, {
    key: KEY_CAB_ATTRIBUTE_TOKEN
  }),
  cabAttributeValue: attr(Boolean, {
    key: KEY_CAB_ATTRIBUTE_VALUE
  }),
  value: alias('cabAttributeValue'),
  valueString: alias('value'),
  hasValue: notEmpty('value'),
  attributeToken: alias('cabAttributeToken')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), CAB_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), CAB_ATTRIBUTES);
  }
});
const CAE_ATTRIBUTES = [{
  key: KEY_CAE_ATTRIBUTE_TOKEN,
  name: 'caeAttributeToken'
}, {
  key: KEY_CAE_ATTRIBUTE_VALUE,
  name: 'caeAttributeValue'
}];
export const CustomAttributeEmail = Filter.extend({
  caeAttributeToken: attr(String, {
    key: KEY_CAE_ATTRIBUTE_TOKEN
  }),
  caeAttributeValue: attr(String, {
    key: KEY_CAE_ATTRIBUTE_VALUE
  }),
  value: alias('caeAttributeValue'),
  valueString: alias('value'),
  hasValue: notEmpty('value'),
  attributeToken: alias('caeAttributeToken')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), CAE_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), CAE_ATTRIBUTES);
  }
});
const CAEN_ATTRIBUTES = [{
  key: KEY_CAEN_ATTRIBUTE_TOKEN,
  name: 'caenAttributeToken'
}, {
  key: KEY_CAEN_ATTRIBUTE_VALUES,
  name: 'caenAttributeValues',
  isArray: true
}, {
  key: KEY_CAEN_ATTRIBUTE_OPTIONS,
  name: 'caenAttributeOptions',
  isArray: true
}, {
  key: KEY_CAEN_CONDITION,
  name: 'caenCondition'
}];
export const CustomAttributeEnum = Filter.extend({
  caenAttributeToken: attr(String, {
    key: KEY_CAEN_ATTRIBUTE_TOKEN
  }),
  caenAttributeValues: repeated(String, {
    key: KEY_CAEN_ATTRIBUTE_VALUES
  }),
  caenAttributeOptions: repeated(String, {
    key: KEY_CAEN_ATTRIBUTE_OPTIONS
  }),
  caenCondition: attr(Condition, {
    key: KEY_CAEN_CONDITION
  }),
  value: alias('caenAttributeValues'),
  hasValue: notEmpty('value'),
  attributeToken: alias('caenAttributeToken'),
  options: alias('caenAttributeOptions')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), CAEN_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), CAEN_ATTRIBUTES);
  }
});
const CAP_ATTRIBUTES = [{
  key: KEY_CAP_ATTRIBUTE_TOKEN,
  name: 'capAttributeToken'
}, {
  key: KEY_CAP_ATTRIBUTE_VALUE,
  name: 'capAttributeValue'
}];
export const CustomAttributePhone = Filter.extend({
  capAttributeToken: attr(String, {
    key: KEY_CAP_ATTRIBUTE_TOKEN
  }),
  capAttributeValue: attr(String, {
    key: KEY_CAP_ATTRIBUTE_VALUE
  }),
  value: alias('capAttributeValue'),
  valueString: alias('value'),
  hasValue: notEmpty('value'),
  attributeToken: alias('capAttributeToken')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), CAP_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), CAP_ATTRIBUTES);
  }
});
const CAT_ATTRIBUTES = [{
  key: KEY_CAT_ATTRIBUTE_TOKEN,
  name: 'catAttributeToken'
}, {
  key: KEY_CAT_ATTRIBUTE_VALUE,
  name: 'catAttributeValue'
}, {
  key: KEY_CAT_CONDITION,
  name: 'catCondition'
}];
export const CustomAttributeText = Filter.extend({
  catAttributeToken: attr(String, {
    key: KEY_CAT_ATTRIBUTE_TOKEN
  }),
  catAttributeValue: attr(String, {
    key: KEY_CAT_ATTRIBUTE_VALUE
  }),
  catCondition: attr(Condition, {
    key: KEY_CAT_CONDITION
  }),
  value: alias('catAttributeValue'),
  valueString: alias('value'),
  hasValue: notEmpty('value'),
  attributeToken: alias('catAttributeToken')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), CAT_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), CAT_ATTRIBUTES);
  }
});
const CSF_ATTRIBUTES = [{
  key: KEY_CSF_CS_CREATION_SOURCE_TYPES,
  name: 'creationSourceTypes',
  isArray: true,
  isOption: true
}, {
  key: KEY_CSF_CS_CREATION_SOURCE_TYPES_OPTIONS,
  name: 'creationSourceTypesOptions',
  isArray: true,
  isOption: true
}];
export const CreationSource = Filter.extend({
  creationSourceTypes: repeated(String, {
    key: KEY_CSF_CS_CREATION_SOURCE_TYPES
  }),
  creationSourceTypesOptions: repeated(Option, {
    key: KEY_CSF_CS_CREATION_SOURCE_TYPES_OPTIONS
  }),
  value: alias('creationSourceTypes'),
  hasValue: notEmpty('value'),
  options: alias('creationSourceTypesOptions')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), CSF_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), CSF_ATTRIBUTES);
  }
});
const FB_ATTRIBUTES = [{
  key: KEY_FB_SENTIMENT_TYPE,
  name: 'fbSentimentType',
  isOption: true
}, {
  key: KEY_FB_SENTIMENT_TYPE_OPTIONS,
  name: 'fbSentimentTypeOptions',
  isArray: true,
  isOption: true
}];
export const Feedback = Filter.extend({
  fbSentimentType: attr(Option, {
    key: KEY_FB_SENTIMENT_TYPE
  }),
  fbSentimentTypeOptions: repeated(Option, {
    key: KEY_FB_SENTIMENT_TYPE_OPTIONS
  }),
  value: alias('fbSentimentType'),
  valueString: alias('value.label'),
  hasValue: notEmpty('value'),
  options: alias('fbSentimentTypeOptions')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), FB_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), FB_ATTRIBUTES);
  }
});
const GF_ATTRIBUTES = [{
  key: KEY_GF_GROUP_TOKEN,
  name: 'groupToken'
}];
export const GroupFilter = Filter.extend({
  groupToken: attr(String, {
    key: KEY_GF_GROUP_TOKEN
  }),
  value: alias('groupToken'),
  valueString: alias('value'),
  hasValue: notEmpty('value')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), GF_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), GF_ATTRIBUTES);
  }
});
const HCOF_ATTRIBUTES = [{
  key: KEY_HCOF_HAS_CARD_ON_FILE,
  name: 'hcofHasCardOnFile'
}];
export const HasCardOnFile = Filter.extend({
  hcofHasCardOnFile: attr(Boolean, {
    key: KEY_HCOF_HAS_CARD_ON_FILE
  }),
  value: alias('hcofHasCardOnFile'),
  valueString: alias('value'),
  hasValue: notEmpty('value')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), HCOF_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), HCOF_ATTRIBUTES);
  }
});
const HL_ATTRIBUTES = [{
  key: KEY_HL_HAS_LOYALTY,
  name: 'hlHasLoyalty'
}];
export const HasLoyalty = Filter.extend({
  hlHasLoyalty: attr(Boolean, {
    key: KEY_HL_HAS_LOYALTY
  }),
  value: alias('hlHasLoyalty'),
  valueString: alias('value'),
  hasValue: notEmpty('value')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), HL_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), HL_ATTRIBUTES);
  }
});
const HVL_ATTRIBUTES = [{
  key: KEY_HVL_LOCATIONS,
  name: 'hvlLocations',
  isArray: true,
  isOption: true
}, {
  key: KEY_HVL_LOCATIONS_OPTIONS,
  name: 'hvlLocationsOptions',
  isArray: true,
  isOption: true
}];
export const HasVisitedLocation = Filter.extend({
  hvlLocations: repeated(Option, {
    key: KEY_HVL_LOCATIONS
  }),
  hvlLocationsOptions: repeated(Option, {
    key: KEY_HVL_LOCATIONS_OPTIONS
  }),
  value: alias('hvlLocations'),
  valueString: alias('value.firstObject.label'),
  hasValue: notEmpty('value'),
  options: alias('hvlLocationsOptions'),
  allowsMultipleChoices: true
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), HVL_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), HVL_ATTRIBUTES);
  }
});
const IIP_ATTRIBUTES = [{
  key: KEY_IIP_IS_INSTANT_PROFILE,
  name: 'iipIsInstantProfile'
}];
export const IsInstantProfile = Filter.extend({
  iipIsInstantProfile: attr(Boolean, {
    key: KEY_IIP_IS_INSTANT_PROFILE
  }),
  value: alias('iipIsInstantProfile'),
  valueString: alias('value'),
  hasValue: notEmpty('value')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), IIP_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), IIP_ATTRIBUTES);
  }
});
const LPILYD_ATTRIBUTES = [{
  key: KEY_LPILYD_Y_DAYS,
  name: 'lpilydYDays',
  isOption: true
}, {
  key: KEY_LPILYD_Y_DAYS_OPTIONS,
  name: 'lpilydYDaysOptions',
  isArray: true,
  isOption: true
}];
export const LastPaymentInLastYDays = Filter.extend({
  lpilydYDays: attr(Option, {
    key: KEY_LPILYD_Y_DAYS
  }),
  lpilydYDaysOptions: repeated(Option, {
    key: KEY_LPILYD_Y_DAYS_OPTIONS
  }),
  value: alias('lpilydYDays'),
  valueString: alias('value.label'),
  hasValue: notEmpty('value'),
  options: alias('lpilydYDaysOptions')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), LPILYD_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), LPILYD_ATTRIBUTES);
  }
});
const MG_ATTRIBUTES = [{
  key: KEY_MG_GROUP_TOKENS,
  name: 'groupTokens'
}];
export const ManualGroup = Filter.extend({
  groupTokens: repeated(String, {
    key: KEY_MG_GROUP_TOKENS
  }),
  value: alias('groupTokens'),
  valueString: alias('value'),
  hasValue: notEmpty('value')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), MG_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), MG_ATTRIBUTES);
  }
});
const NPILYD_ATTRIBUTES = [{
  key: KEY_NPILYD_Y_DAYS,
  name: 'npilydYDays',
  isOption: true
}, {
  key: KEY_NPILYD_Y_DAYS_OPTIONS,
  name: 'npilydYDaysOptions',
  isArray: true,
  isOption: true
}];
export const NoPaymentInLastYDays = Filter.extend({
  npilydYDays: attr(Option, {
    key: KEY_NPILYD_Y_DAYS
  }),
  npilydYDaysOptions: repeated(Option, {
    key: KEY_NPILYD_Y_DAYS_OPTIONS
  }),
  value: alias('npilydYDays'),
  valueString: alias('value.label'),
  hasValue: notEmpty('value'),
  options: alias('npilydYDaysOptions')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), NPILYD_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), NPILYD_ATTRIBUTES);
  }
});
const SQ_ATTRIBUTES = [{
  key: KEY_SQ_SEARCH_QUERY,
  name: 'sqSearchQuery'
}];
export const SearchQuery = Filter.extend({
  sqSearchQuery: attr(String, {
    key: KEY_SQ_SEARCH_QUERY
  }),
  value: alias('sqSearchQuery'),
  valueString: alias('value'),
  hasValue: notEmpty('value')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), SQ_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), SQ_ATTRIBUTES);
  }
});
const XPILYD_ATTRIBUTES = [{
  key: KEY_XPILYD_X_PAYMENTS,
  name: 'xpilydXPayments'
}, {
  key: KEY_XPILYD_X_PAYMENTS_FIELD_NAME,
  name: 'xpilydXPaymentsFieldName'
}, {
  key: KEY_XPILYD_Y_DAYS,
  name: 'xpilydYDays',
  isOption: true
}, {
  key: KEY_XPILYD_Y_DAYS_OPTIONS,
  name: 'xpilydYDaysOptions',
  isArray: true,
  isOption: true
}, {
  key: KEY_XPILYD_Y_DAYS_FIELD_NAME,
  name: 'xpilydYDaysFieldName'
}];
export const XPaymentsInLastYDays = Filter.extend({
  xpilydXPayments: attr(Number, {
    key: KEY_XPILYD_X_PAYMENTS
  }),
  xpilydXPaymentsFieldName: attr(String, {
    key: KEY_XPILYD_X_PAYMENTS_FIELD_NAME
  }),
  xpilydYDays: attr(Option, {
    key: KEY_XPILYD_Y_DAYS
  }),
  xpilydYDaysOptions: repeated(Option, {
    key: KEY_XPILYD_Y_DAYS_OPTIONS
  }),
  xpilydYDaysFieldName: attr(String, {
    key: KEY_XPILYD_Y_DAYS_FIELD_NAME
  }),
  value: alias('xpilydXPayments'),
  value2: alias('xpilydYDays'),
  valueString: computed('xpilydXPayments', 'xpilydYDays.label', function () {
    return `${this.xpilydXPayments} - ${this.xpilydYDays?.label}`;
  }),
  hasValue: computed('value', 'value2', function () {
    return isPresent(this.value) && isPresent(this.value2);
  }),
  options2: alias('xpilydYDaysOptions'),
  fieldName: reads('xpilydXPaymentsFieldName'),
  fieldName2: reads('xpilydYDaysFieldName')
}).reopenClass({
  deserialize(data) {
    return deserialize(data, this._super(data), XPILYD_ATTRIBUTES);
  },
  serialize(data) {
    return serialize(this._super(data), XPILYD_ATTRIBUTES);
  }
});

// Serialization and deserialization:

Filter.reopenClass({
  deserialize(data) {
    switch (data.type) {
      case Type.CREATION_SOURCE_FILTER:
        return CreationSource.deserialize(data);
      case Type.CUSTOM_ATTRIBUTE_BOOLEAN:
        return CustomAttributeBoolean.deserialize(data);
      case Type.CUSTOM_ATTRIBUTE_EMAIL:
        return CustomAttributeEmail.deserialize(data);
      case Type.CUSTOM_ATTRIBUTE_ENUM:
        return CustomAttributeEnum.deserialize(data);
      case Type.CUSTOM_ATTRIBUTE_PHONE:
        return CustomAttributePhone.deserialize(data);
      case Type.CUSTOM_ATTRIBUTE_TEXT:
        return CustomAttributeText.deserialize(data);
      case Type.FEEDBACK:
        return Feedback.deserialize(data);
      case Type.GROUP_FILTER:
        return GroupFilter.deserialize(data);
      case Type.HAS_CARD_ON_FILE:
        return HasCardOnFile.deserialize(data);
      case Type.HAS_LOYALTY:
        return HasLoyalty.deserialize(data);
      case Type.HAS_VISITED_LOCATION:
        return HasVisitedLocation.deserialize(data);
      case Type.IS_INSTANT_PROFILE:
        return IsInstantProfile.deserialize(data);
      case Type.LAST_PAYMENT_IN_LAST_Y_DAYS:
        return LastPaymentInLastYDays.deserialize(data);
      case Type.MANUAL_GROUP:
        return ManualGroup.deserialize(data);
      case Type.NO_PAYMENT_IN_LAST_Y_DAYS:
        return NoPaymentInLastYDays.deserialize(data);
      case Type.SEARCH_QUERY:
        return SearchQuery.deserialize(data);
      case Type.X_PAYMENTS_IN_LAST_Y_DAYS:
        return XPaymentsInLastYDays.deserialize(data);
      default:
        return this._super(data);
    }
  },
  serialize(data) {
    switch (data.get('type')) {
      case Type.CREATION_SOURCE_FILTER:
        return CreationSource.serialize(data);
      case Type.CUSTOM_ATTRIBUTE_BOOLEAN:
        return CustomAttributeBoolean.serialize(data);
      case Type.CUSTOM_ATTRIBUTE_EMAIL:
        return CustomAttributeEmail.serialize(data);
      case Type.CUSTOM_ATTRIBUTE_ENUM:
        return CustomAttributeEnum.serialize(data);
      case Type.CUSTOM_ATTRIBUTE_PHONE:
        return CustomAttributePhone.serialize(data);
      case Type.CUSTOM_ATTRIBUTE_TEXT:
        return CustomAttributeText.serialize(data);
      case Type.FEEDBACK:
        return Feedback.serialize(data);
      case Type.GROUP_FILTER:
        return GroupFilter.serialize(data);
      case Type.HAS_CARD_ON_FILE:
        return HasCardOnFile.serialize(data);
      case Type.HAS_LOYALTY:
        return HasLoyalty.serialize(data);
      case Type.HAS_VISITED_LOCATION:
        return HasVisitedLocation.serialize(data);
      case Type.IS_INSTANT_PROFILE:
        return IsInstantProfile.serialize(data);
      case Type.LAST_PAYMENT_IN_LAST_Y_DAYS:
        return LastPaymentInLastYDays.serialize(data);
      case Type.MANUAL_GROUP:
        return ManualGroup.serialize(data);
      case Type.NO_PAYMENT_IN_LAST_Y_DAYS:
        return NoPaymentInLastYDays.serialize(data);
      case Type.SEARCH_QUERY:
        return SearchQuery.serialize(data);
      case Type.X_PAYMENTS_IN_LAST_Y_DAYS:
        return XPaymentsInLastYDays.serialize(data);
      default:
        return this._super(data);
    }
  }
});
export function deserialize(data, record, attributes = []) {
  for (const attribute of attributes) {
    const {
      key,
      isArray,
      isOption,
      name
    } = attribute;
    const value = isPresent(data[key]) ? data[key] : data[underscore(key)];
    if (isArray) {
      if (isOption) {
        record.set(name, isPresent(value) ? value.map(option => Option.create(option)) : undefined);
      } else {
        record.set(name, isPresent(value) ? value.map(item => item) : undefined);
      }
    } else {
      if (isOption) {
        record.set(name, isPresent(value) ? Option.create(value) : undefined);
      } else {
        record.set(name, isPresent(value) ? value : undefined);
      }
    }
  }
  return record;
}
export function serialize(json, attributes = []) {
  for (const attribute of attributes) {
    const {
      key,
      name
    } = attribute;

    // Check several possible keys the attribute could be stored under.
    const value1 = json[key];
    /* eslint-disable no-param-reassign */
    const value2 = json[underscore(key)];
    const value3 = json[underscore(name)];
    json[key] = isPresent(value1) ? value1 : isPresent(value2) ? value2 : value3;

    // Remove potential duplicate storage of attribute under non-standard keys.
    delete json[underscore(key)];
    delete json[underscore(name)];
    /* eslint-enable no-param-reassign */
  }
  return json;
}

// Helper functions:
export function createSearchQueryFilter(searchTerm) {
  return SearchQuery.create({
    type: Type.SEARCH_QUERY,
    sqSearchQuery: searchTerm
  });
}